import { Colors } from '../../../../../themes/colors';
import OfficeAvatarIcon from '../../../../../images/office-avatar.svg';
import StarIcon from '../../../../../images/star_Green.png';

export const Header = ({ user, job }) => {
  const { profile_image: profileImage, average_rating: averageRating } = user || {};

  return (
    <div
      style={{
        width: '100vw',
        height: '125px',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 48,
        gap: 35,
        backgroundColor: '#445963',
      }}
    >
      <img
        src={profileImage || OfficeAvatarIcon}
        style={{
          backgroundSize: 'contain',
          objectFit: 'cover',
          width: '102px',
          borderRadius: '50%',
        }}
        alt="profile"
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          fontSize: 30,
          color: Colors.white,
          maxWidth: '80%',
        }}
      >
        <span>
          {job.officeName || user.office_name}
          {averageRating ? (
            <>
              <img
                src={StarIcon}
                className="card-img-left"
                width="30px"
                alt="star_icon"
                style={{ marginBottom: 10, marginLeft: 13 }}
              />
              {averageRating.toFixed(1)}
            </>
          ) : null}
        </span>
        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {job.title || ''}
        </div>
      </div>
    </div>
  );
};
